<script>
    import dressing from "@intellectability/platform-common";

    import {create_security_error} from "@intellectability/platform-common/utils";
    // common constants
    import {ACTIONS} from "@intellectability/platform-common/constants";

    // common components
    import {
        ExportButtons,
        FlexList,
        ChoosePersonModal,
        toast,
        Icon
    } from "@intellectability/platform-common/sv";

    // bootstrap
    import {
        Breadcrumb,
        BreadcrumbItem,
        Card,
        CardBody,
        Col,
        Container,
        Row
    } from "@sveltestrap/sveltestrap";

    import { getContext, setContext } from "svelte";

    import {fade} from "svelte/transition";
    
    import CriticalIncidentFormModal from "./lib/CriticalIncidentFormModal.svelte";

    let {context} = $props();

    const {
        CRITICAL_INCIDENTS_GLOBAL_LIST,
        CRITICAL_INCIDENTS_PERSON_LIST,
        CRITICAL_INCIDENT_UPDATE,
        CRITICAL_INCIDENT_PDF
    } = ACTIONS;

    let isLoggedIn = $state(false);
    let loading = $state(true);


    /**
     * @type {{
     * userActions: number[]
     * businessRules: BusinessRule[]
     * applicationConfig: {[x: string]: string;}
     * userData: Object|false
     }} */
    let userSecurity = $state.raw({
        userActions: [],
        businessRules: [],
        applicationConfig: {},
        userData: false
    });

    // Selected incident to be edited
    let selectedIncidentId = $state(undefined);
    // Selected cons_id to create a new incident for
    let selectedConsId = $state(undefined);

    let openIncidentModal = $state(false);
    
    // flexlist data
    /** @type {CriticalIncidentListEntry[]} */
    let criticalIncidents = $state.raw([]);
    
    // for dropdowns
    let criticalIncidentStatuses = $state([]); // id are arbitrary, non-sensical and unused
    
    // filter options
    let filterForPerson = $state("");
    let filterForTitle = $state("");
    let filterForStatus = $state("");
    let filterForIncidentDate = $state("");
    let filterForWriter = $state("");
    let filterForProvider = $state("");

    // action access
    let canManage = $derived(userSecurity.userActions.includes(CRITICAL_INCIDENT_UPDATE));

    // pagination
    let pagination = $state({
        show: true,
        page: 1,
        limit: 10,
        recordsFiltered: -1,
        recordsTotal: -1,
        pageLengthMenu: [10, 25, 50, 100, 500]
    });

    // sort
    /** @type {{field: string, order: 'asc'|'desc'}} */
    let sort = $state({
        field: "name",
        order: "asc"
    });

    // column filters take the string
    let criticalIncidentStatusesOptions = $derived(criticalIncidentStatuses.map(function (status) {
        return {name: status.status, value: status.status};
    }));

    $effect( () => {
        if(!loading && isLoggedIn) {
            fetch_filter_list();
        }
    });

    $effect(function load() {
        dressing.api.get_user_security().then(
            (
                response
            ) => {
                if (response.success === true) {
                    const {business_rules, application_config, logged_in_user, logged_in} = response;

                    const securityData = {
                        businessRules: business_rules || [],
                        userActions: logged_in_user.actions || [],
                        applicationConfig: application_config || {},
                        userData: logged_in_user || false,
                    };

                    isLoggedIn = logged_in;

                    // @ts-ignore;
                    userSecurity = securityData;
                    
                    userSecurity.userData = securityData.userData;
                    userSecurity.applicationConfig = securityData.applicationConfig;
                    userSecurity.businessRules = securityData.businessRules;
                    userSecurity.userActions = securityData.userActions;

                    // user requires access to the CASE NOTES LIST (GLOBAL OR PERSON)
                    if (
                        !securityData.userActions.includes(CRITICAL_INCIDENTS_GLOBAL_LIST) &&
                        !securityData.userActions.includes(CRITICAL_INCIDENTS_PERSON_LIST)
                    ) {
                        const security_error = create_security_error("App.svelte", "CriticalIncident",
                        CRITICAL_INCIDENTS_PERSON_LIST);
                        dressing.api.report_security_error(security_error);
                    }
                    
                    const needed_initial_data = [
                        dressing.get("/cm/critical_incidents/statuses").then(({data: response}) => {
                            const {success, data} = response;
                            if (success === true) {
                                criticalIncidentStatuses = data.statuses;
                                return true;
                            }
                            return false;
                        }),
                    ];

                    Promise.allSettled(needed_initial_data).then(function (resolved) {
                        // @ts-ignore
                        const success = resolved.every(r => r.value === true);
                        if (success) {
                            loading = false;
                        } else {
                            toast.error("Error loading initial data");
                        }
                    });

                }
            }
        );
    });

    function fetch_filter_list() {
        const filter_query = {
            name: filterForPerson || null,
            description: filterForTitle || null,
            status_name: filterForStatus || null,
            incident_date_fmt: filterForIncidentDate || null,
            provider: filterForProvider || null,
            created_by_fmt: filterForWriter || null
        };

        const sort_query = {
            sort: sort.field || null,
            order: sort.order || null
        };

        const page_query = {
            page: pagination.page || null,
            limit: pagination.limit || null
        };

        
        dressing.get("/cm/critical_incidents", {
            params: Object.assign(filter_query, {...sort_query, ...page_query})
        }).then(({data: response}) => {
            const {success, data} = response;
            if (success === true) {
                if (data.critical_incidents) {
                    criticalIncidents = data.critical_incidents;
                    pagination.recordsFiltered = data.recordsFiltered;
                    pagination.recordsTotal = data.recordsTotal;
                }
            }
            loading = false;
        }).catch(function (error) {
            loading = false;
            toast.error("Error fetching critical incidents");
        });
    }

    /**
     * @param {string} id
     * @param {string} consId
     */
    function editCriticalIncident(id, consId) {
        if (canManage && id.length > 0) {
            selectedIncidentId = id;
            selectedConsId = consId.length > 0 ? consId : undefined;
            openIncidentModal = true;
        }
    }

    /**
     * @param {string} id
     */
    function pdfCriticalIncident(id) {
        if (canManage && id.length > 0) {
            window.open(`/index.php?action=${CRITICAL_INCIDENT_PDF}&id=${id}`, "_blank");
        }
    }

    function createCriticalIncidentForConsId(/** @type {{value:string, text:string}} */ person){
        selectedConsId = person.value.length > 0 ? person.value : undefined;
        openIncidentModal = true;
    };

</script>

<Breadcrumb divider={" "} class="breadcrumbs mb-3">
    <BreadcrumbItem>Case Management</BreadcrumbItem>
    <BreadcrumbItem class="mx-3">
        <Icon icon="chevron-right"/>
    </BreadcrumbItem>
    <BreadcrumbItem class="mx-1">
        <Icon icon="ambulance"/>
    </BreadcrumbItem>
    <BreadcrumbItem>Critical Incidents</BreadcrumbItem>
</Breadcrumb>
<!-- Page Title -->
<h1>
    <Icon icon="ambulance"/>
    Critical Incidents
</h1>
<!-- Export Buttons -->
<div class="d-flex w-100 justify-content-end mb-3">
    <ExportButtons
            show={["excel", "pdf"]}
            href="ajax/default/ajax.download_list.php?list={CRITICAL_INCIDENTS_GLOBAL_LIST}"
    />
</div>
<!-- TABLE -->
<FlexList
        {loading}
        pagerConfig={pagination}
        onpagechange={(/** @type {number} */ page) => (pagination.page = page)}
        onsort={(/** @type {string} */ field, /** @type {'asc'|'desc'} */ order) => {sort = { field, order };}}
        onpagelengthchange={(/** @type {number} */ newLimit) => (pagination.limit = newLimit)}
        columns={[
            {
                name: "Person",
                field: "cons_name",
                width: "",
                sortedBy: sort.field === "name" ? sort.order : undefined,
                sortable: true,
                collapse: false, // do not hide when in mobile view
                filterType: "text",
                filterPlaceholder: "Search",
                onfilter: function (/** @type {string} */ value) {
                    filterForPerson = value;
                }
            },
            {
                name: "Incident Title",
                field: "description",
                width: "",
                sortedBy: sort.field === "description" ? sort.order : undefined,
                sortable: true,
                collapse: false, // do not hide when in mobile view
                filterType: "text",
                filterPlaceholder: "Search",
                onfilter: function (/** @type {string} */ value) {
                    filterForTitle = value;
                },
            },
            {
                name: "Status",
                field: "status_name",
                width: "",
                sortedBy: sort.field === "status_name" ? sort.order : undefined,
                sortable: true,
                filterType: "select",
                filterOptions: criticalIncidentStatusesOptions,
                onfilter: function (/** @type {string} */ value) {
                    filterForStatus = value;
                },
            },
            {
                name: "Dated",
                field: "incident_date_fmt",
                width: "",
                sortedBy: sort.field === "incident_date_fmt" ? sort.order : undefined,
                sortable: true,
                collapse: false, // do not hide when in mobile view
                filterType: "text",
                filterPlaceholder: "Search",
                onfilter: function (/** @type {string} */ value) {
                    filterForIncidentDate = value;
                },
            },
            {
                name: "Provider",
                field: "prv_name",
                width: "",
                sortable: true,
                sortedBy: sort.field === "prv_name" ? sort.order : undefined,
                filterType: "text",
                filterPlaceholder: "Search",
                onfilter: function (/** @type {string} */ value) {
                    filterForProvider = value;
                },
            },
            {
                name: "Written By",
                field: "created_by_fmt",
                width: "",
                sortable: true,
                sortedBy: sort.field === "created_by_fmt" ? sort.order : undefined,
                filterType: "text",
                filterPlaceholder: "Search",
                onfilter: function (/** @type {string} */ value) {
                    filterForWriter = value;
                },
            },
            {
                name: "Actions",
                width: "110px",
                field: "",
                buttons: [
                    {
                        icon: "file-pdf",
                        tooltip: "Generate PDF",
                        variant: "neutral",
                        action: function (event, /** @type {CriticalIncidentListEntry} */ row) {
                            const { id } = row;
                            pdfCriticalIncident(id);
                        }
                    },
                    {
                        icon: "pencil",
                        tooltip: "Edit",
                        variant: "neutral",
                        action: function (event, /** @type {CriticalIncidentListEntry} */ row) {
                            const { id, cons_id } = row;
                            editCriticalIncident(id, cons_id);
                        },
                        disabled: function (/** @type {CriticalIncidentListEntry} */ row) {
                            return !(row.allow_edit === "Y" && canManage);
                        }
                    },
                ],
            },
        ]}
        expandableRowsComponent={expansionSnipped}
        data={criticalIncidents}>
</FlexList>

<div class="mb-5">
    {#if canManage}
        <ChoosePersonModal context="critical_incidents" onselect={createCriticalIncidentForConsId}
            confirmButtonText="Create New Critical Incident" />
    {/if}
</div>

<CriticalIncidentFormModal
    criticalIncidentId={selectedIncidentId}
    criticalIncidentConsId={selectedConsId}
    onclose={() => {
        fetch_filter_list();
        selectedIncidentId = undefined;
        selectedConsId = undefined;
    }}
    bind:modalOpen={openIncidentModal}
    criticalIncidentStatuses={criticalIncidentStatuses}
/>


{#snippet expansionSnipped(
    /** @type object */ row,
    /** @type object */ index
)}
    <Card class="m-1">
        <!-- <CardHeader></CardHeader> -->
        <CardBody>
            <Container>
                <Row cols={{ lg: 4, md: 4, sm: 2, xs: 2 }}>
                    <Col class='fw-bold'>Person Served</Col>
                    <Col>{row['cons_name']}</Col>
                    <Col class='fw-bold'>Status</Col>
                    <Col>{row['status_name']}</Col>
                    <Col class='fw-bold'>Incident Date</Col>
                    <Col>{row['incident_date_fmt']}</Col>
                    <Col class='fw-bold'>Incident Time</Col>
                    <Col>{row['incident_time']}</Col>
                    <Col class='fw-bold'>Description</Col>
                    <Col>{row['description']}</Col>
                    <Col class='fw-bold'>Reported By</Col>
                    <Col>{row['reported_by']}</Col>
                    <Col class='fw-bold'>Agencies Contacted</Col>
                    <Col>{row['agencies_contacted']}</Col>
                    <Col class='fw-bold'>Witness Info</Col>
                    <Col>{row['witness_info']}</Col>
                    <Col class='fw-bold'>Details</Col>
                    <Col>{row['details']}</Col>
                    <Col class='fw-bold'>Location</Col>
                    <Col>{row['location']}</Col>
                </Row>
            </Container>
        </CardBody>
        <!-- <CardFooter></CardFooter> -->
    </Card>
{/snippet}